module.exports = __webpack_public_path__ + "img/collection-diamondJewelry100Carat@2x.e53523c.jpg";